import { connect } from 'react-redux';

import { LabelList } from '@lt/components/components/Label/LabelList';
import { getIsMobile } from 'src/store/view/selectors';
import styled from 'styled-components';
import { tourLabelsSelector } from '../../../../store/selectors/tour';

const mapStateToProps = (state, props) => ({
  labels: tourLabelsSelector(state, props.tourId),
  isMobile: getIsMobile(state),
});

const connector = connect(mapStateToProps);

const StyledLabelList = styled(LabelList)<{ isMobile?: boolean }>`
  margin-bottom: ${(props) => (props.isMobile ? '16px' : '4px')};
`;

export default connector(StyledLabelList);
